<app-lfsa-card *ngIf="mostrarFormularioProcesar" [innTemplate]="enviarTemplate"
               [titulo]="'Sistema de Cobros Autoservicios'">
</app-lfsa-card>
<ng-template #enviarTemplate>
  <div [formGroup]="formulario" class="form-group" novalidate>
    <!-- {{ formulario.value | json}} -->
    <div class="row col 12">
      <div class="form-group col-md-3">
        <app-lfsa-input-search (devolverAccion)="callModal($event)" (keydown.enter)="cargarCliente($event)"
                               [control]="formularioEditar.get('idCliente')"
                               [label]="'Cliente'" [path]="'Cliente'"
                               [placeholder]="'Cliente'" formControlName="idCliente">
        </app-lfsa-input-search>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('idClientePadre')"
                        [id]="'idClientePadre'" [isReadOnly]="BloquearCampo" [label]="'Cliente Padre*'"
                        [type]="'text'" formControlName="idClientePadre"></app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('dscaClientePadre')"
                        [id]="'dscaClientePadre'" [isReadOnly]="BloquearCampo"
                        [label]="'Nombre Cliente Padre*'"
                        [type]="'text'" formControlName="dscaClientePadre"></app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbClientVinculado"
                            [control]="formulario.get('clientVinculado')"
                            [habilitar]="!BloquearCombo" [idOpcion]="'id'"
                            [id]="'clientVinculado'"
                            [label]="'Cliente Vinculado*'" [opcion]="'valor'"
                            formControlName="clientVinculado"></app-lfsa-combo-box>
      </div>
    </div>
    <div class="row col 12">
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)="onCargarBanco($event.target)" [claseLabel]="'letrasDanger'"
                            [comboBox]="cmbEmpresa"
                            [control]="formulario.get('idEmpresa')" [idOpcion]="'idEmpresa'" [id]="'idEmpresa'"
                            [label]="'Empresa*'" [opcion]="'dscaEmpresa'" formControlName="idEmpresa">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)="onChequeObligatorio($event.target)" [claseLabel]="'letrasDanger'"
                            [comboBox]="cmbTipoPago"
                            [control]="formulario.get('idViaPago')" [idOpcion]="'idViaPago'" [id]="'idViaPago'"
                            [label]="'Vìa de Pago*'" [opcion]="'dscaViaPago'" formControlName="idViaPago">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbEstructura"
                            [control]="this.formulario.get('idParamCobrosAutoServ')"
                            [idOpcion]="'idParametro'" [id]="'idParametro'"
                            [label]="'Estructura de Parametros*'"
                            [opcion]="'nombreFormato'"
                            formControlName="idParamCobrosAutoServ"></app-lfsa-combo-box>
      </div>
    </div>
    <div class="row col 12">
      <div class="form-group col-md-6">
        <app-lfsa-combo-box (change)="onCargarCuentaClave($event.target)" [claseLabel]="'letrasDanger'"
                            [comboBox]="cmbBanco"
                            [control]="this.formulario.get('idBanco')" [idOpcion]="'idBanco'" [id]="'idBanco'"
                            [label]="'Banco*'" [opcion]="'dscaBanco'" formControlName="idBanco">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-input (input)="this.formulario.patchValue({ctaBancaria: $any($event.target).value.toUpperCase()})"
                        [claseLabel]="'letrasDanger'"
                        [control]="formulario.get('ctaBancaria')"
                        [id]="'ctaBancaria'"
                        [isReadOnly]="BloquearCampo" [label]="'N° Cuenta Bancaria*'" [type]="'text'"
                        formControlName="ctaBancaria">
        </app-lfsa-input>
      </div>
    </div>
    <div class="row col 12">
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('numCheque')"
                        [id]="'numCheque'" [isReadOnly]="bloquearCheque" [label]="'N° de Cheque*'"
                        [type]="'number'" formControlName="numCheque"></app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('referencia')"
                        [id]="'referencia'" [label]="'N° Referencia Bancaria*'" [type]="'number'"
                        formControlName="referencia"></app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('valorPago')"
                        [id]="'valorPago'" [label]="'Valor Pago*'" [type]="'number'" formControlName="valorPago">
        </app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('fechaDocumento')" [id]="'fechaFinal'"
                        [label]="'Fecha Documento*'" [type]="'date'"
                        formControlName="fechaDocumento">
        </app-lfsa-input>
      </div>
    </div>
    <br>
    <div class="row col-12">
      <div class="form-group col-md-12">
        <label for="csvInput">Abrir .csv</label>
        <input #fileInput (change)="onFileSelect($event)" accept=".csv" class="form-control-file" id="csvInput"
               type="file"/>
      </div>
    </div>
    <br>
    <div *ngIf="formulario.invalid" class="row col-12">
      <div class="form-group col-12">
        <div class="alert alert-danger animated fadeInRight" role="alert">
          <h5><b> El botón se activará cuando complete toda la información requerida que está marcada con (*)
          </b>
          </h5>
        </div>
      </div>
    </div>
    <div class="row col-12">
      <div class="form-group col-md-12">
        <button (click)="acciones ( 'guardar' )" [disabled]="formulario.invalid"
                class="{{DAT_BTNCSS.successLg}}">Procesar
        </button>
      </div>
    </div>
  </div>
</ng-template>


<app-lfsa-card *ngIf="mostrarFormularioGuardar" [innTemplate]="enviarTemplateProceso"
               [titulo]="'Proceso de Cobros Autoservicios'"></app-lfsa-card>
<ng-template #enviarTemplateProceso>
  <div class="row col 12">
    <div class="form-group col-md-6">
      <h5><b>Cliente:</b> {{ dataCliente.dscaCliente }}</h5>
    </div>
    <div class="form-group col-md-6">
      <h5><b>Cliente Vinculado:</b> {{ dataCliente.clientVinculado ? 'SI' : 'No' }}</h5>
    </div>
  </div>
  <div class="row col 12">
    <div class="form-group col-md-6">
      <h5><b>Cliente Padre:</b> {{ dataCliente.dscaClientePadre }}</h5>
    </div>
    <div class="form-group col-md-6">
      <h5 *ngIf="dataCliente.numCheque"><b>N° Cheque:</b> {{ dataCliente.numCheque }}</h5>
    </div>
  </div>
  <div class="row col 12">
    <div class="form-group col-md-6">
      <h5><b>N° Referencia Bancaria:</b> {{ dataCliente.referencia }}</h5>
    </div>
    <div class="form-group col-md-6">
      <h5><b>Fecha:</b> {{ dataCliente.fechaHora.substring(0, 10) }}</h5>
    </div>
  </div>
  <div class="row col 12">
    <div class="form-group col-md-3">
      <h5><b>Hora:</b> {{ dataCliente.fechaHora.substring(11, 19) }}</h5>
    </div>
  </div>

  <div class="row col 12">
    <div class="form-group col-md-3">
      <br>
      <button (click)="regresarFomularioProcesar()" class="{{ DAT_BTNCSS.danger }}">
        <i aria-hidden="true" class="fa fa-undo"></i>
        Regresar
      </button>
    </div>
    <div class="form-group col-md-3">
      <br>
      <button (click)="acciones('reProcesar')" class="{{ DAT_BTNCSS.primary}}">
        <i aria-hidden="true" class="fa fa-refresh"></i>
        {{ DAT_BTNS.validar }}
      </button>
    </div>
    <div class="form-group col-md-3">
      <br>
      <button (click)="clickSustento()" class="{{ DAT_BTNCSS.warningFile}}">
        <i aria-hidden="true" class="fa fa-picture-o"></i>
        {{ DAT_BTNS.sustento }}
      </button>
    </div>
    <div class="form-group col-md-3" hidden="true">
      <br>
      <span class="{{DAT_BTNCSS.warningLgFile}}">
                <input #pngInput (change)="onFileSelect($event)" accept=".png" class="form-control-file" id="pngInput"
                       type="file"/>{{ DAT_BTNS.sustento }}
            </span>
    </div>
    <div class="form-group col-md-3">
      <br>
      <button (click)="acciones('guardar')" [disabled]="btnGuardar" class="{{DAT_BTNCSS.success}}">
        <i aria-hidden="true" class="fa fa-floppy-o"></i>
        {{ DAT_BTNS.guardar }}
      </button>
    </div>
  </div>

  <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs "
                   [floatingFilter]="true" [frameworkComponents]="frameworkComponents "
                   [ngStyle]="cobroAutoModulo.agGrid.style" [paginationPageSize]="cobroAutoModulo.agGrid.paginacion"
                   [pagination]="true" [rowData]="rowData "
                   [rowSelection]="rowSelection "
                   class="{{cobroAutoModulo.agGrid.class}}" id="{{cobroAutoModulo.agGrid.id}}">
  </ag-grid-angular>

</ng-template>

<app-lfsa-card *ngIf="mostrarFormularioEditar" [innTemplate]="enviarTemplateEditar"
               [titulo]="'Editar Detalle Documento'">
</app-lfsa-card>
<ng-template #enviarTemplateEditar>
  <div [formGroup]="formularioEditar" class="form-group" novalidate>
    <div class="row col 12">
      <div class="form-group col-md-6">
        <!-- <app-lfsa-input-search [path]="'Cliente'" formControlName="idCliente" [placeholder]="'Cliente'"
            [label]="'Cliente'" [control]="formularioEditar.get('idCliente')"
            (devolverAccion)="setClienteEditar($event)"
            (keydown.enter)="cargarClienteEditar($event)"></app-lfsa-input-search> -->
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formularioEditar.get('dscaCliente')"
                        [id]="'dscaCliente'" [isReadOnly]="BloquearCampo" [label]="'Nombre*'" [type]="'text'"
                        formControlName="dscaCliente">
        </app-lfsa-input>
      </div>
    </div>
    <div class="row col 12">
      <div class="form-group col-md-6">
        <app-lfsa-input
          (input)="this.formularioEditar.patchValue({idTipoTrans: $any($event.target).value.toUpperCase()})"
          [claseLabel]="'letrasDanger'"
          [control]="formularioEditar.get('idTipoTrans')"
          [id]="'idTipoTrans'"
          [label]="'Tipo Transaccion*'" [type]="'text'" formControlName="idTipoTrans"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formularioEditar.get('noDocumento')"
                        [id]="'noDocumento'" [label]="'Número Documento*'" [type]="'number'"
                        formControlName="noDocumento">
        </app-lfsa-input>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <button (click)="btnEditarRegresar()" class="{{DAT_BTNCSS.dangerLg}}">Regresar</button>
        </div>
        <div class="col">
          <button (click)="btnEditarForm()" [disabled]="formularioEditar.invalid"
                  class="{{DAT_BTNCSS.successLg}}">Editar
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-lfsa-modal [idButton]="'Cliente'" [idClose]="'cerrarModa'" [idOpen]="'Modal'" [innTemplate]="enviarModalSustento"
                [titulo]="'Clientes'"></app-lfsa-modal>
<ng-template #enviarModalSustento>
  <form *ngIf="!mostrar" [formGroup]="formularioModal" class="form-group" novalidate>
    <div class="row">
      <div class="form-group col-md-6">
        <app-lfsa-input [control]="formularioModal.get('codigo1')" [id]="'codigo1'" [label]="'Código desde:'"
                        [placeholder]="'Código'"
                        [type]="'number'" formControlName="codigo1"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-input [control]="formularioModal.get('codigo2')" [id]="'codigo2'" [label]="'Código hasta:'"
                        [placeholder]="'Código'"
                        [type]="'number'" formControlName="codigo2"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-input [control]="formularioModal.get('ruc1')" [id]="'ruc1'" [label]="'RUC desde:'"
                        [placeholder]="'RUC'"
                        [type]="'number'" formControlName="ruc1"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-input [control]="formularioModal.get('ruc2')" [id]="'ruc2'" [label]="'RUC hasta:'"
                        [placeholder]="'RUC'"
                        [type]="'number'" formControlName="ruc2"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-input [control]="formularioModal.get('nombre')" [id]="'nombre'" [label]="'Nombre:'"
                        [placeholder]="'Nombre'"
                        formControlName="nombre"></app-lfsa-input>
      </div>

    </div>
    <button (click)="mostrarTabla()" class="btn btn-outline-success">BUSCAR</button>
  </form>
  <div *ngIf="mostrar">
    <div *ngIf="!loading">
      <button (click)="mostrarFormulario()" class="btn btn-outline-success">NUEVA BUSCAR</button>
      <ag-grid-angular [columnDefs]="columnDefsModal" [frameworkComponents]="frameworkComponentsModal"
                       [pagination]="true" [rowData]="rowDataModal"
                       [rowSelection]="rowSelectionModal" class="ag-theme-alpine mt-3"
                       style="width: 100%; height: 450px;">
      </ag-grid-angular>
    </div>
    <div *ngIf="loading" class="containerLoader">
      <div class="item-1"></div>
      <div class="item-2"></div>
      <div class="item-3"></div>
      <div class="item-4"></div>
      <div class="item-5"></div>
    </div>
  </div>
</ng-template>
